<template>
  <div class="about-inner">
    <section class="about-auditlink">
      <h1 class="blue">{{ title }}</h1>
      <p class="lead-in">{{ pageLeadIn }}</p>
      <div v-html="content"></div>
    </section>

    <section class="directors">
      <h1 class="blue">Our Directors</h1>

      <div class="profile" v-for="director in directors" :key="director.name">
        <div class="profile-image">
          <img :src="director.image" alt="">
        </div>
        <div class="profile-content">
          <h2>{{ director.name }}</h2>
          <span class="subtitle red">{{ director.title }}</span>

          <p>{{ director.bio }}</p>

          <a :href="'tel:' + director.phone" class="phone"><span class="red">P</span> {{ director.phone }}</a>
          <a :href="'mailto:' + director.email" class="email"><span class="red">E</span> {{ director.email }}</a>
        </div>
      </div>
    </section>

    <section class="team">
      <h1>Our Team</h1>
      <div class="team-profiles">
        <div class="team-member" v-for="member in team" :key="member.name">
          <header class="member-header">
            <img :src="member.image" alt="">
            <div class="member-name">
              <h2>{{ member.name }}</h2>
            </div>
          </header>
          <div class="member-details">
            <span class="subtitle red">{{ member.position }} <a :href="'mailto:' + member.email"><img src="../assets/font-awesome-mail.svg" class="email-link-icon" alt=""></a></span>
          </div>
        </div>
      </div>
    </section>

    <section class="join">
      <h1>Join the team</h1>
      <p class="lead-in">{{ join.leadIn }}</p>
      <div v-html="join.content"></div>
      <div class="external-links">
        <a href="mailto:info@auditlink.co.nz" class="button button-independent"><span>Get in touch</span> <img src="../assets/forward-arrow-dark.svg" alt=""></a>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AboutSingle',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      title: 'About AuditLink',
      content: '',
      pageLeadIn: '',
      join: {
        leadIn: '',
        content: ''
      },
      directors: [],
      team: [],
      metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'About Us'
      }
    }
  },

  metaInfo () {
    return {
      title: this.metaInfo.title
    }
  },

  mounted () {
    axios.get(process.env.ENDPOINT, {
      params: {
        slug: 'about-us'
      }
    }).then(response => {
      this.content = response.data[0].content.rendered
      this.pageLeadIn = response.data[0].acf.lead_in
      this.directors = response.data[0].acf.directors
      this.team = response.data[0].acf.team
      this.join.leadIn = response.data[0].acf.join_the_team.lead_in
      this.join.content = response.data[0].acf.join_the_team.content
      this.metaInfo.title = response.data[0].title.rendered
      document.dispatchEvent(new Event('content-loaded'))
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AboutSingle.vue